import React from 'react'
import FilterForm from 'views/ScanSettings/components/FilterForm'

const NewFilter = ({ form, isScanCompare, isDetailsView }) => {
	return <FilterForm form={form} nested={false} isScanCompare={isScanCompare} isDetailsView={isDetailsView} />
}

export default NewFilter
